import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalContent from 'LuxKit/Modal/ModalContent'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import Group from 'components/utils/Group'
import MarkdownRender from 'LuxKit/MarkdownRender'
import ModalImageThumbnail from 'LuxKit/Modal/ModalImageThumbnail'
import styled from 'styled-components'
import { rem } from 'polished'

const Wrapper = styled.div`
  padding-bottom: ${rem(20)};
`

function ModalStep(props: App.ComponentContentModal) {
  return <>
    <ModalHeader
      title={props.title}
      key={props.slug}
    />
    <ModalBody>
      <ModalImageThumbnail image={props.image} imageParams={{ aspectRatio: '3.15' }} />
      <Wrapper>
        <ModalContent>
          <Group direction="vertical" gap={12}>
            <MarkdownRender fontSize="medium" type="compact" content={props.bodyText} />
          </Group>
        </ModalContent>
      </Wrapper>
    </ModalBody>
  </>
}

export default ModalStep
